import React, { useState, useEffect } from "react";
import { generateClient } from 'aws-amplify/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Orders = ({ selectedVendorForFiltering , selectedProductForFiltering, setSelectedOrderForFiltering, allMode}) => {
    const client = generateClient();
    const [orders, setOrders] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [selectedOrderId, setSelectedOrderId] = useState(null);

    async function fetchData() {
        try {
            const retrieveOrders = await client.graphql({
                query: `
               query MyQuery {
                orders {
                    created_at
                    id
                    message
                    practice_name
                    practice_user_email
                    practice_user_name
                    status
                    updated_at
                    product {
                        id
                    }
                    vendor {
                        id
                    }
                }
                }
            `,
                authMode: 'userPool',
            });

            const sortedOrders = retrieveOrders.data.orders.sort((a, b) => a.id - b.id);
            setOrders(sortedOrders);
            setFilteredOrders(sortedOrders); // Initially display all orders
        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    }

    // Handle search term input
    const handleSearch = (e) => {
        setSearchTerm(e.target.value);

        // Filter orders based on search term
        const filtered = orders.filter((order) =>
            order.practice_user_email?.toLowerCase().includes(e.target.value.toLowerCase()) ||
            order.message?.toLowerCase().includes(e.target.value.toLowerCase()) ||
            order.user_name?.toLowerCase().includes(e.target.value.toLowerCase()) ||
            order.id.toString().includes(e.target.value)
        );
        setFilteredOrders(filtered);
    };

    useEffect(() => {
        let filtered = orders;
        if (selectedVendorForFiltering) {
            filtered = filtered.filter((order) =>
                order.vendor && order.vendor.id && order.vendor.id === selectedVendorForFiltering
            );
        }
        if (selectedProductForFiltering) {
            filtered = filtered.filter((order) =>
                order.product && order.product.id && order.product.id === selectedProductForFiltering
            );
        }
        setFilteredOrders(filtered);
    }, [selectedVendorForFiltering, selectedProductForFiltering, orders]);

    useEffect(() => {
        fetchData();
    }, []);

    const handleRowClick = (orderId) => {
        setSelectedOrderId(orderId);
        if (orderId === null) {
            setSelectedOrderForFiltering(null);
            setFilteredOrders(orders);
        } else {
            setSelectedOrderForFiltering(orderId);
            const filtered = orders.filter((order) => order.id === orderId);
            setFilteredOrders(filtered);
        }
        if (allMode) {
            setSelectedOrderForFiltering(orderId);
        }
    };

    return (
        <div className="mt-5">
            <div>Orders</div>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="input-group w-50">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search for orders by ID, name, email, status, etc."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>
            </div>

            <div className="table-responsive">
                <table className="table table-striped table-bordered table-hover">
                    <thead className="thead-dark">
                        <tr>
                            {allMode ? <th></th> : null}
                            <th>ID</th>
                            <th>Vendor ID</th>
                            <th>Practice Name</th>
                            <th>Message</th>
                            <th>User Email</th>
                            <th>User Name</th>
                            <th>Status</th>
                            {/* <th>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredOrders.map((order) => (
                            <tr key={order.id} onClick={() => setSelectedOrderId(order.id)}>
                                {allMode ? (
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={order.id === selectedOrderId}
                                            onChange={() => {
                                                if (order.id === selectedOrderId) {
                                                    handleRowClick(null)
                                                } else {
                                                    handleRowClick(order.id)
                                                }
                                            }}
                                        />
                                    </td>) : null}
                                <td>{order.id}</td>
                                <td>{order.vendor.id}</td>
                                <td>{order.practice_name}</td>
                                <td style={{
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}>
                                    {order.message}
                                </td>
                                <td>{order.user_email}{order.practice_user_email}</td>
                                <td>{order.user_name}{order.practice_user_name}</td>
                                <td
                                style={{
                                    backgroundColor: order.status == "CLOSED" ? 'green' : order.status == "AWAITING USER ACTION" ? 'orange' : order.status == "AWAITING VENDOR ACTION" ? 'blue' : 'transparent',
                                    color: order.status == "CLOSED" ? 'white' : order.status == "AWAITING USER ACTION" ? 'black' : order.status == "AWAITING VENDOR ACTION" ? 'blue' : 'black'
                                }}
                                >{order.status}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Orders;
